<template>
  <div>
    <div v-if="!hasData">
      <NoData msg="亲，暂无退款/售后单哦"/>
    </div>
    <div v-if="hasData">
      <ItemSup :data="list" @Jump="Jump"/>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import ItemSup from "@/components/ItemSup.vue";
import { GetSup } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
export default {
  components: {
    ItemSup,
    NoData
  },
  props: ["state"],
  data() {
    return {
      active: 0,
      page: 1,
      list: [],
      hasData: false
    };
  },
  created() {
    GetSup(this.state, this.page, getLocalStorage("login_token")).then(res => {
      let data = res.data.list.data;
      if (data.length > 0) this.hasData = true;
      for (let i in data) {
        this.list.push({
          id: data[i].order_refund_id,
          time: data[i].create_time,
          state: data[i].state_text,
          name: data[i].order_goods.goods_name,
          price: data[i].order_goods.total_price,
          num: data[i].order_goods.total_num,
          img: data[i].order_goods.image.file_path,
          pay: data[i].order_goods.total_pay_price
        });
      }
    });
  },
  activated() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    Jump(id){
        this.$router.push({
            path:'/supportdetail',
            query:{
                id:id
            }
        })
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
</style>